import * as React from "react";
const SvgFiRrSteeringWheel = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-steering-wheel_svg__a)">
      <path
        fill="#062147"
        d="M12 0A12 12 0 0 0 0 12c.59 15.905 23.416 15.89 24 0A12 12 0 0 0 12 0m0 2a10.01 10.01 0 0 1 8.878 5.4l-7.049 1.41a9.6 9.6 0 0 1-3.8 0L3.108 7.428A10.01 10.01 0 0 1 12 2M9 21.54a10.03 10.03 0 0 1-6.935-8.4l3.9.78a3 3 0 0 1 2.05 1.515l.624 1.153A3 3 0 0 1 9 18.014zm6 0v-3.526a3 3 0 0 1 .362-1.428l.624-1.154a3 3 0 0 1 2.05-1.514l3.9-.78A10.03 10.03 0 0 1 15 21.54m2.644-9.583a4.99 4.99 0 0 0-3.416 2.522l-.628 1.154a5 5 0 0 0-.6 2.381v3.936c-.665.066-1.335.066-2 0v-3.936a5 5 0 0 0-.6-2.381l-.628-1.153a4.99 4.99 0 0 0-3.416-2.523l-4.314-.863a10 10 0 0 1 .324-1.775l7.272 1.454a11.6 11.6 0 0 0 4.583 0l7.406-1.481c.166.588.277 1.191.331 1.8z"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-steering-wheel_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrSteeringWheel;
